import { Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { SiteSettingsService } from './site-settings.service';

@Injectable({
	providedIn: 'root',
})
export class MetaService {
	private titleService = inject(Title);
	private metaService = inject(Meta);
	private settings = inject(SiteSettingsService);

	/**
	 * Set meta tags for a specific page.
	 * Settings are already loaded via APP_INITIALIZER — no async needed.
	 */
	setPageMeta(page: 'home' | 'services' | 'about' | 'blog' | 'blog-detail') {
		this.applyMetaTags(page);
	}

	private applyMetaTags(page: 'home' | 'services' | 'about' | 'blog' | 'blog-detail') {
		let title = '';
		let description = '';

		switch (page) {
			case 'home':
				title = this.settings.val('seo_meta', 'meta_home_title', 'OG Studio');
				description = this.settings.val('seo_meta', 'meta_home_description');
				break;
			case 'services':
				title = this.settings.val('seo_meta', 'meta_services_title', 'Our Services - OG Studio');
				description = this.settings.val('seo_meta', 'meta_services_description');
				break;
			case 'about':
				title = this.settings.val('seo_meta', 'meta_about_title', 'About Us - OG Studio');
				description = this.settings.val('seo_meta', 'meta_about_description');
				break;
			case 'blog':
				title = this.settings.val('seo_meta', 'meta_blog_title', 'Blog - OG Studio');
				description = this.settings.val('seo_meta', 'meta_blog_description');
				break;
			case 'blog-detail':
				// Handled separately in the blog detail component
				return;
		}

		this.setMeta(title, description);
	}

	/**
	 * Set custom meta tags (for dynamic pages like blog posts)
	 */
	setCustomMeta(title: string, description: string) {
		this.setMeta(title, description);
	}

	private setMeta(title: string, description: string) {
		this.titleService.setTitle(title);
		this.metaService.updateTag({ name: 'description', content: description });
		this.metaService.updateTag({ property: 'og:title', content: title });
		this.metaService.updateTag({ property: 'og:description', content: description });
		this.metaService.updateTag({ name: 'twitter:title', content: title });
		this.metaService.updateTag({ name: 'twitter:description', content: description });
	}

	resetMeta() {
		this.setPageMeta('home');
	}
}
